import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom";

import {
  CContainer,
  CCard,
  CCardBody,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableHeaderCell,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CFormInput,
  CButton,
  CModalBody,
  CFormCheck,
  CFormSelect,
  CModalHeader,
  CModalTitle,
  CModal,
  CModalFooter
} from "@coreui/react";

import CIcon from "@coreui/icons-react";
import {
  cilPlus,
  cilPencil,
  cilX,
  cilList,
  cilShieldAlt,
  cilSearch,
  cilExternalLink,
  cilSortAscending
} from "@coreui/icons";

import style from "./index.module.css"
import Pagination from 'src/components/Paginations/paginations';


import { getCandidatesByBatchId } from './viewCandidatesApi';
import { deleteCandidates } from '../ManageCandidates/manageCandidatesApi';
import { ManageBatch } from 'src/Router/Routes';
import PreviusButton from 'src/components/PreviousButton';

function index() {
  const queryParams = new URLSearchParams(window.location.search);
  const batchId = queryParams.get('batchId');
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [visibleDeleteBox, setVisibleDeleteBox] = useState(false);
  const [CheckboxCandidate, setCheckboxCandidate] = useState([]);
  const [selectedRows, setSelectedRows] = useState({});
  const [deletedCandidate, setDeletedCandidate] = useState([])
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    sort: 1,
  });

  useEffect(() => {
    if (!batchId) {
      navigate(ManageBatch);
    }
  }, [batchId, navigate]);

  const setPage = (data) => {
    console.log("------------------", data)
    setCurrentPage(data.currentPage)
  };

  useEffect(() => {
    (async function () {
      try {
        let res = await getCandidatesByBatchId(currentPage, params.limit, batchId);
        setTableData(res.data);
        console.log(res, "-------------************")
        setTotalPages(res.totalPages);
        // setCurrentPage(res.currentPage)
        setParams({ ...params, limit: res.limit, page: currentPage })
        setTotalRecords(res.totalRecord)

      } catch (error) {
        console.error('Error occurred:', error);
      }
    })();
  }, [currentPage, params.limit])

  const handleDeleteType = (Id) => {
    setVisibleDeleteBox(true);
  };

  async function handleAddLimit(e) {
    console.log("number", e.target.value)
    if (e.target.value == "All") {
      setParams({ ...params, limit: Number(totalRecords) })
    } else {
      setParams({ ...params, limit: Number(e.target.value) })
    }
  }


  const handleRowSelect = async (id) => {
    if (CheckboxCandidate[id]) {
      // If the ID exists in state, remove it
      setCheckboxCandidate(prevState => {
        const newState = { ...prevState };
        delete newState[id];
        return newState;
      });
    } else {
      // If the ID doesn't exist in state, add it
      setCheckboxCandidate(prevState => ({
        ...prevState,
        [id]: "Available"
      }));
    }

  };

  const handleSelectAll = async (event) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      getCandidatesByBatchId(currentPage, params.limit, batchId)
        .then(result => {
          // Access the data property
          const data = result.data;
          // console.log(data, "++++++++++++++++++++++++++++++++++++++++++++++++++");
          const pageIds = data.map(item => item.id);
          console.log(pageIds, "PageIDS")

          setCheckboxCandidate(prevState => ({
            ...prevState,
            ...pageIds.reduce((acc, curr) => ({ ...acc, [curr]: "Available" }), {})
          }));

          setSelectedRows(prevState => ({
            ...prevState,
            [currentPage]: "Available"
          }));

        })
        .catch(error => {
          console.error('Error fetching records for page', ':', error);
        });

      // setSelectedRows([...allIds]);
    } else {
    
      const res = await getCandidatesByBatchId(currentPage, params.limit, batchId);
      const newData = res.data;
      console.log(newData, "newData-------------")
      // Remove all keys from checkboxCandidate state
      setCheckboxCandidate(prevState => {
        const newState = { ...prevState };
        newData.forEach(item => {
          if (newState[item.id]) {
            delete newState[item.id];
          }
        });
        return newState;
      });
  
      // Remove current page key from selectedRows state
      setSelectedRows(prevState => {
        const newState = { ...prevState };
        delete newState[currentPage];
        return newState;
      });
    }

  };

  const handleCandididateClick = async () => {
    await deleteCandidates(batchId, Object.keys(CheckboxCandidate))
    let res = await getCandidatesByBatchId(currentPage, params.limit, batchId);
    setTableData(res.data);
    setTotalPages(res.totalPages);
    setTotalRecords(res.totalRecord);
    setCheckboxCandidate({})
  }



  console.log(CheckboxCandidate, "checkbox candidate---------------")
  console.log(selectedRows, "selected rows---------------")

  return (
    <>
      <CContainer fluid>
        <CCard>
          <CCardBody className={`${style.wrapper} d-flex flex-column`}>
            <CRow className="row g-3">
              <CRow>
                <CCol style={{ paddingTop: "20px" }}>
                  <div style={{display: "flex"}}>
                  <PreviusButton />
                  <h4 style={{marginLeft: "15px"}}>View Candidates</h4>
                  </div>
                </CCol>
              </CRow>
              <CRow className="row g-3 align-items-center">


                <CCol xs="auto">
                  <CFormSelect
                    aria-label="Default select example"
                    onChange={handleAddLimit}
                    options={[
                      { label: 'Select Limit', value: '' },
                      { label: '10', value: '10' },
                      { label: '50', value: '50' },
                      { label: '100', value: '100' },
                      { label: '150', value: '150' },
                      { label: '200', value: '200' },
                      { label: '500', value: '500' },
                      { label: 'All', value: 'All' },
                    ]}
                  />
                </CCol>

              </CRow>

            </CRow>


            <CRow className="row g-2">
              {tableData && tableData.length > 0 ? (
                <>
                  <CTable responsive striped style={{ marginTop: "15px" }}>
                    <CTableHead>
                      <CTableRow>
                        <CTableHeaderCell>#</CTableHeaderCell>
                        <CTableHeaderCell>Batch Id</CTableHeaderCell>
                        <CTableHeaderCell>Candidate Id</CTableHeaderCell>
                        <CTableHeaderCell>Candidate Name</CTableHeaderCell>
                        <CTableHeaderCell>Candidate Email Id</CTableHeaderCell>
                        <CTableHeaderCell>
                          Delete
                          <CFormCheck
                          id="checkbox-select-all"
                          onChange={handleSelectAll}
                          checked={!!selectedRows[currentPage]}
                        />
                        </CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {tableData.map((item, index) => (
                        <CTableRow key={item.id} className={style.tableRow}>
                          <CTableDataCell>{(currentPage - 1) * itemsPerPage + index + 1}</CTableDataCell>
                          <CTableDataCell>{item.batch_id}</CTableDataCell>
                          <CTableDataCell>{item.registration_process_cirtificate_id}</CTableDataCell>
                          <CTableDataCell>{item.first_name + "  " + item.last_name}</CTableDataCell>
                          <CTableDataCell>{item.email_id}</CTableDataCell>

                          <CTableDataCell>
                            <CFormCheck
                              id={`checkbox-${item.id}`}
                              checked={!!CheckboxCandidate[item.id]}
                              onChange={() => handleRowSelect(item.id)}
                            />
                          </CTableDataCell>

                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>

                  <Pagination
                    totalRecords={totalRecords}
                    pageLimit={Number(params.limit)}
                    currentPage={currentPage}
                    setPage={setPage}
                  />

                </>
              ) : (
                <CCard className="mt-3">
                  <CCardBody>
                    <h5 className="text-center">No Data available</h5>
                  </CCardBody>
                </CCard>
              )}
            </CRow>
            <CCol xs={12}>
              {Object.keys(CheckboxCandidate).length > 0 && (
                <div className="mt-5 d-flex justify-content-end align-items-center">
                  <CButton type="submit" onClick={handleCandididateClick}>Delete Candidate</CButton>
                </div>
              )}
            </CCol>

          </CCardBody>

        </CCard>


        <CModal
          visible={visibleDeleteBox}
          onClose={() => setVisibleDeleteBox(false)}
        >
          <CModalHeader onClose={() => setVisibleDeleteBox(false)}>
            <CModalTitle>Alert</CModalTitle>
          </CModalHeader>
          <CModalBody>Do you really want to delete this Candidate from batch?</CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setVisibleDeleteBox(false)}>
              Close
            </CButton>
            <CButton color="primary" onClick={handleDeleteType}>
              Yes
            </CButton>
          </CModalFooter>
        </CModal>

      </CContainer>
    </>
  )
}

export default index
